// extracted by mini-css-extract-plugin
export default {"brandFilter":"styles_brandFilter__wYmDo"};